import PropTypes from "prop-types";
import { MiActionMenu } from "../../MiActionMenu/MiActionMenu";

export function MiTableRowActions({
  getRowActions,
  selectedActionRow,
  handleClose,
  anchorEl,
  open,
  rowKey = "",
}) {
  const rowActions = getRowActions(selectedActionRow);

  if (!selectedActionRow || !rowActions.length) {
    return null;
  }

  return (
    <MiActionMenu
      open={open}
      selectedActionRow={selectedActionRow}
      rowActions={rowActions}
      handleClose={handleClose}
      anchorEl={anchorEl}
      rowKey={rowKey}
    />
  );
}

MiTableRowActions.propTypes = {
  getRowActions: PropTypes.func,
  selectedActionRow: PropTypes.object,
  handleClose: PropTypes.func,
  anchorEl: PropTypes.object,
  open: PropTypes.bool,
  rowKey: PropTypes.string,
};
